import classNames from 'classnames';
import { forwardRef, type Ref } from 'react';
import { ColorBadge } from '../../types';
import setDenaliAttribute from '../../utils/setDenaliAttribute';
import styles from './styles/styles.module.scss';
import { formatBadgeNumber } from './utils';

export type CounterBadgeProps = {
  className?: string;
  color?: ColorBadge;
  round?: boolean;
  title?: string;
  limit?: number;
  count?: number;
  text?: string;
};

const CounterBadge = ({ className, color = 'default', round, title, limit, count, text }: CounterBadgeProps, ref: Ref<HTMLElement>) => {
  const classes = classNames(styles.span, styles[color], className);

  return (
    <span
      {...setDenaliAttribute('CounterBadge')}
      className={classes}
      title={title || text || count?.toString() || ''}
      ref={ref as Ref<HTMLSpanElement>}
    >
      {text ? text : count && formatBadgeNumber(count, limit, round)}
    </span>
  );
};

export default forwardRef(CounterBadge);
